export default "__VITE_ASSET__f8117cb6__"